module.exports = __webpack_public_path__ + "img/uk-endocrine-nutritional-metabolic-diseases-female.3805ff8b.png";